<div class="popup-header">Update Sites</div>
<br>
<div mat-dialog-content>

  <mat-selection-list #list *ngFor="let company of companies | async">
    <mat-toolbar mat-subheader>{{company.companyId | uppercase}}</mat-toolbar>
    <mat-list-option *ngFor="let site of company.sites" (click)="onNgModelChange(site)" [selected]="site.active"
      [value]="site.siteId">
      {{site.name | titlecase}}
    </mat-list-option>
  </mat-selection-list>

</div>
<div mat-dialog-actions align="end">
  <button mat-button (click)="onNoClick()">Close</button>
  <button class="theme-button" type="button" [mat-dialog-close]="selectedOptions" mat-raised-button>Save
  </button>
</div>
